import React from "react";
import { AppDataTable } from "../../ui";

/**
 * SkippedTable — who will not be (or was not) added to a batch, or removed
 * from one, and the server's reason, one row each. The reasons are sentences
 * the admin acts on ("Has already completed this course."), so they are shown
 * as written.
 */
const SkippedTable = ({ rows, terms }) => {
  const columns = [
    {
      key: "name",
      label: terms.singular,
      render: (r) => (
        <span className="tw-flex tw-flex-col">
          <span className="tw-font-medium tw-text-content">{r.name || "Not found"}</span>
          {r.mobile && <span className="tw-text-xs tw-text-content-subtle">{r.mobile}</span>}
        </span>
      ),
    },
    {
      key: "reason",
      label: "Why",
      render: (r) => <span className="tw-text-[0.8125rem] tw-text-content-muted">{r.reason}</span>,
    },
  ];

  return (
    <AppDataTable
      fill={false}
      columns={columns}
      rows={rows}
      rowKey={(r) => String(r.studentId)}
    />
  );
};

export default SkippedTable;
